<template>
	<div :id="id" class="accordion-list">
		<div v-if="title" class="accordion-list__title">
			{{ title }}
		</div>
		<div v-if="sponsorText" class="accordion-list_sponsor">
			<span class="accordion-list_sponsor-text">
				{{ sponsorText }}
			</span>
			<DefaultIcon
				v-if="sponsorLogo"
				:logo="sponsorLogo"
				class="accordion-list_sponsor-logo"
			></DefaultIcon>
		</div>
		<AccordionItem
			v-for="item in items"
			:id="item.id"
			:key="item.title"
			:ga4="item.ga4"
		>
			<template #icon>
				<DefaultIcon
					v-if="item.logo && item.logo.src"
					class="default-icon__img"
					:logo="item.logo"
				>
				</DefaultIcon>
				<SvgIcon
					v-else-if="item.icon"
					:icon="item.icon"
					:color="item.iconColor"
				/>
			</template>
			<template #title>
				<div>
					{{ item.title }}
				</div>
			</template>
			<template #content v-if="item.richText">
				<div v-html="item.richText"></div>
			</template>
		</AccordionItem>
	</div>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const id = computed(() => props.fields?.id?.value);
const title = computed(() => props.fields?.title?.value);
const sponsorText = computed(() => props.fields?.sponsorText?.value);
const sponsorLogo = computed(() => props.fields?.sponsorLogo?.value);
const items = computed(() => {
	return props.fields?.accordionItems?.map((item) => {
		return {
			id: item.fields?.id?.value,
			icon: item.fields?.icon?.value,
			iconColor: item.fields?.iconColor?.value,
			logo: item.fields?.logo?.value,
			title: item.fields?.title?.value,
			richText: item.fields?.richText?.value,
			ga4: item.fields?.ga4?.value,
		};
	});
});
</script>

<style lang="scss">
.accordion-list {
	margin: 0px var(--spacing-2, 16px);

	.accordion-item {
		padding: var(--spacing-2, 16px) 0px;
		border-bottom: 1px solid #cbcbcb;
	}

	.accordion-item__button {
		padding: 0;
	}

	.accordion-list__title {
		margin-bottom: var(--spacing-3, 24px);
		color: var(--color-white, #fff);
		font-size: var(--text-xl, 24px);
		font-family: var(--primary-font, sans-serif);
		font-weight: 900;
		line-height: 110%;
		text-transform: uppercase;
	}

	.accordion-list_sponsor {
		display: flex;
		align-items: baseline;

		.accordion-list_sponsor-text {
			color: var(--color-white, #fff);
			font-size: var(--text-2xs, 10px);
			font-weight: 700;
			line-height: 120%;
			text-transform: uppercase;
			width: 40%;
			margin-bottom: var(--spacing-3, 24px);
		}

		.accordion-list_sponsor-logo {
			width: 50%;
		}

		.accordion-list_sponsor-logo .default-icon__img {
			width: 100%;
			height: 100%;
		}
	}

	.accordion-item__content {
		color: var(--color-grey-3, #989898);

		h1,
		h2,
		h3,
		h4,
		h5,
		h6 {
			color: var(--color-white, #fff);
			font-size: var(--text-base, 16px);
			font-weight: 700;
			line-height: 120%;
		}
	}
}
</style>
